//
import UserModel from '@/models/General/GUser'

//
import { required } from '@/services/validations'

//
import DetailPurchaseOrderEditedHeaders from '@/views/Purchase/PchPurchaseOrderEdited/PchDetailPurchaseOrderEditedHeaders'

//
export default props => [
    {
        name: 'pch_purchase_order_id',
        type: 'text-field',
        flex: {
            lg3: true,
            sm6: true,
        },
        props: {
            label: 'N° de orden de compra',
            readonly: true,
        },
    },
    {
        name: 'g_originator_user_id',
        type: 'autocomplete-model',
        flex: {
            lg3: true,
            sm6: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
            rules: [ required ],
        },
    },
    {
        name: 'g_authorizer_user_id',
        type: 'autocomplete-model',
        flex: {
            lg3: true,
            sm6: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Supervisor',
            model: UserModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
            rules: [ required ],
        },
    },
    {
        name: 'pch_purchase_order_state_name',
        type: 'text-field',
        flex: {
            lg3: true,
            sm6: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
        },
    },
    {
        name: 'pch_selected_purchase_order_detail',
        type: 'table-field',
        flex: {
            'pt-0': true,
            'xs12': true,
            'd-grid': true,
        },
        props: {
            checkable: true,
            headers: props.is_service ? DetailPurchaseOrderEditedHeaders.forService : DetailPurchaseOrderEditedHeaders.forProduct,
            noDataText: 'Sin productos.',
            toolbarTitle: 'Lista de productos incluidos en la edición de la orden',
            rules: [ required ],
        },
    },
    {
        name: 'authorization_date',
        type: 'date-field',
        flex: {
            lg3: true,
            sm6: true,
        },
        props: {
            label: 'Autorización',
            readonly: true,
        },
    },
    {
        name: 'pch_selected_purchase_orders_net_price_str',
        type: 'text-field',
        flex: {
            'offset-lg6': true,
            lg3: true,
            sm6: true,
        },
        props: {
            label   : 'Total neto',
            readonly: true,
        },
    },
]